import {useCallback} from 'react';
import {ContactData} from './DocumentData';

export type DocumentDraft = {
    documentTypeCode: number;
    fields: Record<string, string>;
    recipients: ContactData[];
    savedAt: string;
};

export function useDocumentDraft(userId: string) {

    const DRAFT_KEY = `epismo_draft_${userId}`;

    const saveDraft = useCallback((draft: Omit<DocumentDraft, 'savedAt'>) => {
        const toSave: DocumentDraft = {
            ...draft,
            savedAt: new Date().toISOString()
        };
        localStorage.setItem(DRAFT_KEY, JSON.stringify(toSave));
    }, [DRAFT_KEY]);

    const loadDraft = useCallback((): DocumentDraft | null => {
        const stored = localStorage.getItem(DRAFT_KEY);
        if (!stored) return null;
        try {
            return JSON.parse(stored) as DocumentDraft;
        } catch {
            return null;
        }
    }, [DRAFT_KEY]);

    const clearDraft = useCallback(() => {
        localStorage.removeItem(DRAFT_KEY);
    }, [DRAFT_KEY]);

    return {saveDraft, loadDraft, clearDraft};
}
